import { createContext, useContext } from "react";

interface CalendarContextType {
  selectDate: "start" | "end" | null;
  disabledWeekdays: number[];
}

const CalendarContext = createContext<CalendarContextType | undefined>(
  undefined,
);

export const useCalendarContext = () => {
  const context = useContext(CalendarContext);
  if (!context) {
    throw new Error("useCalendarContext must be used within CalendarProvider");
  }
  return context;
};

export default CalendarContext;
